import { useEffect, useMemo, useState, startTransition } from 'react'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { setCookie } from 'cookies-next'
import { REGION_COOKIE } from '@/constants/cookies'
import { Durations } from '@/constants/durations'
import { GetViewerRegionQuery } from '@/types/codegen-federation'
import { getRegionFromCookie, overrideOrRegion } from './region-utils'

// Re-export all pure functions so existing imports via barrel continue to work
export {
  getUserRegionFromReq,
  getUserStateFromReq,
  overrideOrRegion,
  isUnitedStates,
  isCanada,
  isUnitedStatesOrCanada,
  isUnitedStatesOrTerritories,
  isDomestic,
  getRegionFromCookie,
} from './region-utils'

const getViewerRegionQuery = gql`
  query getViewerRegion {
    viewer {
      region
    }
  }
`

interface UseUserRegionResult {
  loading: boolean
  region: string | undefined
}

/**
 * This hook is for use client-side only.
 * @returns
 */
export function useUserRegion(): UseUserRegionResult {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    startTransition(() => {
      setMounted(true)
    })
  }, [])

  const result = useQuery<GetViewerRegionQuery>(getViewerRegionQuery, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  })

  return useMemo(() => {
    if (!mounted) {
      return { loading: true, region: undefined }
    }
    const hydraRegion = result?.data?.viewer?.region
    const cookieRegion = getRegionFromCookie()
    const region = overrideOrRegion(hydraRegion || cookieRegion)

    if (hydraRegion) {
      setCookie(REGION_COOKIE, hydraRegion, { maxAge: Durations.ONE_MONTH_IN_SECONDS })
    }

    return { loading: result.loading, region }
  }, [result, mounted])
}
